import React, { Component } from "react";
import Image from "../Image";
export class Input extends Component {
  render() {
    const {
      name,
      image,
      image2,
      height,
      placeholder,
      isShowError,
      inputref,
      label,
      bordercolor,
      isShowPasswordError,
      onClick,
      type,
      className,
      errorMessage,
      isDark,
      required,
      autocomplete,
      onChange,
      onBlur,
      ...rest
    } = this.props;
    return (
      <div
        className={!!isDark ? "marginV" : ""}
        style={{ width: !!this.props.fatcawidth ? "80%" : "100%" }}
      >
        {!isDark && (
          <div className="input-name">
            {name} {label}{" "}  {required&& (<span style={{color:"red"}}>*</span>)}
          </div>
        )}
        <div
          className={!!className ? className : "Input-field-div"}
          style={{
            borderColor:
              isShowError || isShowPasswordError
                ? "red"
                : !!bordercolor
                ? bordercolor
                : "lightgray",
          }}
        >
          {!!image && (
            <Image
              src={`${image}`}
              alt="input-label"
              style={{ height: 20, marginRight: 15 }}
            />
          )}
          {name?.includes("ARN") && !isDark ? (
            <label className="arn_label">ARN -</label>
          ) : (
            ""
          )}
          <form
            autoComplete="off"
            className={
              !!isDark
                ? "input-without-arn-label-dark number-input"
                : "input-without-arn-label number-input"
            }
            onSubmit={(e) => e.preventDefault()}
          >
            <input
              className={
                !!isDark
                  ? "input-without-arn-label-dark number-input"
                  : "input-without-arn-label number-input"
              }
              placeholder={placeholder}
              ref={inputref}
              onKeyDown={this.props.onKeyDown}
              onBlur={onBlur}
              type={type || "text"}
              step={this.props.step}
              disabled={this.props.disabled}
              autocomplete={this.props.autocomplete}
              onChange={onChange}
              {...rest}
              maxLength={!!this.props.maxLengthOverride?80:40}
            />
          </form>

          <div onClick={this.props.onClick}>
            {!!image2 && (
              <Image
                src={`${image2}`}
                alt="field_image"
                height={height || 10}
              />
            )}
          </div>
        </div>

        <div style={{ color: "red", fontFamily: "OpenSans-Italic" }}>
          {isShowError
            ? errorMessage || ` is required.`
            : isShowPasswordError
            ? "Password shoould be atleast 8 characters in length and should contain at least 1 Upper Case alphabet(A-Z).1 Special Character and 1 Numeric Value (0-9)"
            : ""}
        </div>
      </div>
    );
  }
}

export class NpsInput extends Component {
  render() {
    const {
      name,
      placeholder,
      errorMessage,
      onChange,
      onBlur,
      type,
      value,
      isError,
    } = this.props;
    return (
      <div>
        <div style={{ margin: "10px" }}>
          <div style={{ margin: "10px" }}>{name}*</div>
          <input
            style={
              !isError
                ? {
                    borderColor: "rgb(232, 232, 247)",
                    marginLeft: "10px",
                    marginBottom: "10px",
                    width: "240px",
                    height: "48px",
                    borderWidth: "1px",
                    padding: "10px",
                    borderStyle: "solid",
                  }
                : {
                    borderColor: "red",
                    marginLeft: "10px",
                    marginBottom: "10px",
                    width: "240px",
                    height: "48px",
                    borderWidth: "1px",
                    padding: "10px",
                    borderStyle: "solid",
                  }
            }
            onChange={onChange}
            onBlur={onBlur}
            type={type}
            placeholder={!!placeholder ? placeholder : `Enter ${name}`}
            value={value}
          ></input>
          {isError && (
            <div
              style={{ color: "red", marginLeft: "10px", marginTop: "10px" }}
            >
              {!!errorMessage ? errorMessage : `${name} is Mandatory*`}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export class OtpInput extends Component {
  render() {
    const { inputref, ...rest } = this.props;
    return (
      <div>
        <input
          className="otp_input number-input"
          type="number"
          style={{ textAlign: "center" }}
          ref={inputref}
          {...rest}
        />
      </div>
    );
  }
}
